export const empty = {
  object: {},
  array: []
};
//# sourceMappingURL=empty.js.map